import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, ShoppingBag } from 'lucide-react';
import { ProductCard } from './ProductCard';
import { getPricing } from '../data/products';
import { SHOPIFY_PREVIEW_URL } from '../data/contact';
import { useLanguage } from '../contexts/LanguageContext';
import { useCart } from '../contexts/CartContext';
export function ProductsSection() {
  const {
    t
  } = useLanguage();
  const {
    totalItems
  } = useCart();
  const [category, setCategory] = useState('all');
  const visible = t.products.items.filter(product => {
    if (category === 'all') return true;
    return getPricing(product.id)?.category === category;
  });
  return <section id="creations" className="scroll-mt-32 bg-creme py-24 md:py-32" data-id="element-241" data-mp="20oizeh2e1aux">
      <div className="mx-auto max-w-7xl px-6 md:px-12" data-id="element-242" data-mp="20qlzjtx98kdd">
        <div className="mb-10 text-center" data-id="element-243" data-mp="3q50lk6gw1t56">
          <span className="mb-4 block font-sans text-xs uppercase tracking-[0.22em] text-caramel" data-id="element-244" data-mp="3q1w5obu298yo">
            {t.products.eyebrow}
          </span>
          <h2 className="mb-6 font-serif text-3xl text-cacao-900 md:text-5xl" data-id="element-245" data-mp="388j3eu5kke9k">
            {t.products.titleLead}{' '}
            <span className="italic text-or" data-id="element-246" data-mp="33a7qubnw3pnn">{t.products.titleAccent}</span>
          </h2>
          <div aria-hidden="true" className="mx-auto h-px w-24 bg-caramel" data-id="element-247" data-mp="3hyugp7b57zt4" />
        </div>

        <nav aria-label={t.products.categoriesLabel} className="mb-12 flex flex-wrap items-center justify-center gap-3" data-id="element-248" data-mp="3d1lxd3e9dpqa">
          {t.products.categories.map(item => {
          const active = item.id === category;
          return <button key={item.id} type="button" aria-pressed={active} onClick={() => setCategory(item.id)} className={`border px-4 py-2 font-sans text-[10px] uppercase tracking-[0.16em] transition-colors duration-200 ${active ? 'border-cacao-900 bg-cacao-900 text-creme' : 'border-caramel/40 text-cacao-800 hover:border-caramel hover:text-caramel'}`} data-id="element-249" data-mp="2ybwiy6h5np82">
                {item.name}
              </button>;
        })}
        </nav>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-250" data-mp="3cd9xjsum6k3c">
          {visible.map((product, index) => <ProductCard key={product.id} product={product} index={index} data-id="element-251" data-mp="3gcio6oucy1uo" data-mpi={index} />)}
        </div>

        <div className="mt-14 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-252" data-mp="2jp4d777h2x41">
          <Link to="/panier" className="inline-flex items-center gap-3 bg-caramel px-10 py-4 font-sans text-xs uppercase tracking-[0.16em] text-creme transition-colors duration-300 hover:bg-caramel-light" data-id="element-253" data-mp="2onfolmdf1fod">
            <ShoppingBag size={16} strokeWidth={1.5} aria-hidden="true" data-id="element-254" data-mp="2xgskmx6s0xeo" />
            {t.products.orderNow}
            {totalItems > 0 ? ` (${totalItems})` : ''}
          </Link>
          <a href={SHOPIFY_PREVIEW_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 border border-cacao-900 px-10 py-4 font-sans text-xs uppercase tracking-[0.16em] text-cacao-900 transition-colors duration-300 hover:bg-cacao-900 hover:text-creme" data-id="element-255" data-mp="24wu0twd6z0tc">
            <CreditCard size={16} strokeWidth={1.5} aria-hidden="true" data-id="element-256" data-mp="1jfwc1ate0n6m" />
            {t.cart.checkout}
          </a>
        </div>
      </div>
    </section>;
}